import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=53e41b30"
import script from "./register-form.ts?vue&type=script&lang=js&external"
export * from "./register-form.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports